import onMessageDump from "./onMessageDump";
import onMessageMessageNew from "./onMessageMessageNew";
import onMessageMessageStatus from "./onMessageMessageStatus";
import onMessageError from "./onMessageError";

export const onMessageActions = {
  '/chat/dump': onMessageDump,
  '/message/new': onMessageMessageNew,
  '/message/status': onMessageMessageStatus,
  '/error': onMessageError,
}
